import { fetchMETAR, fetchTAFV2, getSNOWTAM } from "./helperfunctions";

/**
 * Fetches all weather data (SNOWTAM, TAF, METAR) for a given ICAO code in parallel
 */
export const fetchAllWeatherData = async (icaoCode) => {
  const [snowtamResult, tafResult, metarResult] = await Promise.allSettled([
    getSNOWTAM(icaoCode).then((snowtam) => snowtam?.[0]),
    fetchTAFV2(icaoCode)
      .then((res) => res.json())
      .then((res) => res?.[0]?.rawTAF),
    fetchMETAR(icaoCode)
      .then((res) => res.json())
      .then((res) => res?.[0]?.METAR?.[0]?.raw_text),
  ]);

  return {
    snowtam:
      snowtamResult.status === "fulfilled" ? snowtamResult.value : null,
    taf: tafResult.status === "fulfilled" ? tafResult.value : null,
    metar: metarResult.status === "fulfilled" ? metarResult.value : null,
  };
};

/**
 * Merges weather data from backend NOTAM response with fetched weather data
 * Uses backend data when available, falls back to fetched data
 */
export const mergeWeatherDataFromBackend = async (
  notamData,
  icaoCode,
  { includeFaaNotam = true } = {},
) => {
  const weatherData = await fetchAllWeatherData(icaoCode);

  return {
    snowtam: notamData.snowtam || weatherData.snowtam,
    taf: notamData.taf?.rawTAF || weatherData.taf,
    metar: notamData.metar?.raw_text || weatherData.metar,
    notam: includeFaaNotam
      ? notamData.errorMsg || notamData.sNOTAM || null
      : null,
  };
};

/**
 * Formats weather data for display, adding fallback messages for missing data
 * Note: snowtam is kept as an object (if present) since the render function expects snowtam?.sSnowtam
 */
export const formatWeatherDataForDisplay = (data) => {
  return {
    // Keep snowtam as object if present, since render expects snowtam?.sSnowtam
    snowtam: data.snowtam || null,
    taf: data.taf || "TAF data not found",
    metar: data.metar || "METAR data not found",
    notam: data.notam || "NOTAM data not found",
  };
};

